import { FormFieldProps, NullableFormValue } from "@eres/forms";
import { ReactElement } from "react";
import { StringUtil } from "@eres/core";

export function getValidationClass<T, XT>( isFocus: boolean, props: FormFieldProps<T, XT>, value: NullableFormValue<T, XT>, error?: string | ReactElement ) {
	const { required } = props;
	if ( isFocus ) {
		return " focus-validation";
	} else if ( required && ( value == null || StringUtil.isEmptyStringOrNull( value + "" ) || error ) ) {
		return " empty-validation";
	} else if ( value !== undefined && !StringUtil.isEmptyStringOrNull( value + "" ) ) {
		return " valid-validation";
	} else if ( error ) {
		return " empty-validation";
	}
	return "";
}
